'use client';

import { useTranslations } from 'next-intl';

import { UiProductTileMedium, Product } from '@/fo/ui/product/tile/medium';

import { eventCareProgram } from '../utils/event';

import { styles } from './UiProductInfoCarePrograms.styles';

export interface UiProductInfoCareProgramsProps {
  products: Product[];
  className?: string;
}

export function UiProductInfoCarePrograms({
  products,
  className
}: UiProductInfoCareProgramsProps) {
  const t = useTranslations();
  const slots = styles();

  return (
    <section className={slots.base({ className })}>
      <h2 className={slots.title()}>{t('CarePrograms')}</h2>

      <div className={slots.products()}>
        {products.map((product) => (
          <UiProductTileMedium
            type="anchor"
            key={product.id}
            product={product}
            onClick={() => eventCareProgram.setId(product.id)}
          />
        ))}
      </div>
    </section>
  );
}
